import { AgeBand } from "../../../../context/dataExperienceContext";

export const getAgeBandLabel = (ageBand: AgeBand): string => {
    const labels: Record<AgeBand, string> = {
        ADULT: 'Adulto',
        SENIOR: 'Senior',
        YOUTH: 'Joven',
        CHILD: 'Niño',
        INFANT: 'Bebé',
        TRAVELER: 'Viajero'
    };
    return labels[ageBand] || ageBand;
};